module.exports = __webpack_public_path__ + "static/assets/c8a5bc72b836ca4f97a957d2c02cdc73.svg";